<template>
	<div class="step-header-wrp display-flex">
		<div v-if="previousSteps.length > 0" class="pr-3">
			<v-btn @click="$emit('prevStep')" class="back-button" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</v-btn>
		</div>
		<slot> </slot>
	</div>
</template>

<script>
export default {
	name: 'CreationWizardStepHeaderWrapper',
	props: {
		previousSteps: { type: Array },
	},
};
</script>

<style lang="scss" scoped>
.back-button {
	margin-right: 5px;
	border-radius: 6px;
	border: 1px solid var(--grey-background);
}
</style>
